
export enum ComponentType {
  FindAvailabilityComponent,
  ClientSelectorComponent,
  ProgramSelectorComponent,
  ExamSelectorComponent,
  ScheduleAppointmentComponent,
  ProgramInformationComponent,
  CustomAgreementComponent,
  AgreementComponent,
  EligibilitySelectorComponent,
  LocationSelectorComponent,
  TestCenterSelecterComponent,
  CandidateProfileComponent,
  PaymentComponent,
  VerificationDetailComponent,
  ConfirmationComponent,
  AppointmentSearchComponent,
  AppointmentInfoComponent,
  RescheduleComponent,
  RescheduleAppointmentComponent,
  ReconfirmationComponent,
  CancellationComponent,
  CancellationAppointment,
  PaymentCancellationComponent,
  CancellationVerificationComponent,
  CancellationConfirmationComponent,
  FindAvailabilityTestcenterComponent,
  FindAvailabilityLocationComponent,
  FindAvailabilityTimezoneComponent,
  FindAvailabilityProctorComponent,
  RescheduleLocationComponent,
  RescheduleTestCenterComponent,
  ScheduleLocationComponent,
  ScheduleTestCenterComponent,
  CandidateSelectableComponent,
  BiometricConsentComponent,
  ScheduleProctorComponent,
  RescheduleProctorComponent,
  ScheduleTimezoneComponent,
  TimezoneSelectorComponent,
  RescheduleTimezoneComponent,
  MultidayTestCenterSelectorComponent,
  MultidayTestCenterComponent,
  RescheduleMultidayTestCenterComponent,
  RescheduleMultidaySessionComponent
}

export enum EntityType {
  client,
  program,
  region,
  exam,
  country,
  selectedStartDate,
  selectedEndDate,
  locationSelector,
  state,
  appointmentSearch,
  booking,
  appointmentDetail,
  candidateData,
  appointmentSummary,
  eligibility,
  hold,
  selectedAppointmentDetail,
  overlapsDate,
  overlapsFromDate,
  overlapsToDate
}

export enum LogLevel {
  Info = <any>'Info',
  Debug = <any>'Debug',
  Warn = <any>'Warn',
  Error = <any>'Error',
  Fatal = <any>'Fatal',
}

export enum MetricType {
  Selected = <any>'Selected',
  Searched = <any>'Searched',
  BestDate = <any>'BestDate',
  BestSite = <any>'BestSite',
}

export enum ErrorMessage {
  BadSchedulingMethod = <any>'ScheduleMethodError',
  EligibilityError = <any>'EligibilityError',
  InvalidEligibility = <any>'InvalidEligibility',
  EligibilityUsedError = <any>'EligibilityUsedError',
  EligibilityExpiredError = <any>'EligibilityExpiredError'
}

export enum DistanceUnits {
  Miles = <any>'mi',
  Kilometers = <any>'km'
}

export enum ExamStatus {
  InvalidSchedulingMethod = <any>'invalid ScheduleMethod'
}

export enum Selection {
  Yes = 'yes',
  No = 'no'
}

export enum Fee {
  CancelFee = 'Cancellation Fee',
  ExamFee = 'Exam Fee',
  InitialScheduleFee = 'Initial Schedule Fee',
  RescheduleFee = 'Reschedule Fee',
  Refund = 'Cancellation Refund',
  RefundFailed = 'Booking Failure Refund',
  PartialRescheduleFee = 'Early Reschedule Fee (Partial)'
}

export enum CardFee {
  Cancel = 'CancelFee',
  Reschedule = 'EarlyRescheduleFee',
  Schedule = 'Fee'
}

export enum QrKey {
  id = 'id',
  reconciliationId = 'reconciliationId',
  reasonCode = 'reasonCode',
  refunded = 'refunded',
  status = 'status',
  successUrl = 'successUrl',
  timeout = 'timeout'
}

export enum QrStatus {
  abandoned = 'abandoned',
  failed = 'failed',
  pending = 'pending',
  refunded = 'refunded',
  settled = 'settled'
}

export enum QrTransactionType {
  sale = 'sale',
  refund = 'refund'
}

export enum NavigationAction {
  backwardsNavigation = 'backwards navigation',
  browserClose = 'browser close',
  customNavigation = 'custom navigation',
  forwardsNavigation = 'forwards navigation',
  hardRefresh = 'hard refresh',
  refresh = 'refresh',
  tabClose = 'tab close'
}

export enum InputType {
  keyboard = 'keyboard',
  mouse = 'mouse',
  proschedulerInternalNavigation = 'Proscheduler internal navigation'
}

export enum PaymentOrchestratorRefundStatus {
  succeeded = 'succeeded',
  failed = 'failed'
}

export enum PaymentOrchestratorPaymentStatus {
  unpaid = 'unpaid',
	paymentInitiated = 'Payment_Initiated',
	paymentSucceeded = 'Payment_Succeeded',
	paymentFailed = 'Payment_Failed',
	paymentExpired = 'Payment_Expired',
	paymentRefunded = 'Payment_Refunded'
}